import React, {useEffect, useState} from "react";
import {createUser} from "../../../redux/Actions";
import {useDispatch} from "react-redux";
import {
    createOrganization,
    fetchOrganizationUserGroupsForUser,
    fetchOrganizationUsers, userLoggedIn
} from "../../../redux/user/Action";
import {selectOrganization} from "../../../redux/models/organizations/Action";
import Loading from "../../elements/Loading";
import {createLeaflogixAccount, createMetrcAccount} from "../../../redux/models/integrations/Action";
import {DUTCHIE, METRC} from "../../../constants";


export const CreatingAccountSpinner = ({
    formState,
    creatingUser,
    creatingOrganization,
    configuringUsers,
    loggingIn,
    creatingIntegration
}) => {
    let title = "Done!";

    if (creatingUser) {
        title = `Creating Your User (${formState.email})...`;
    } else if (creatingOrganization) {
        title = `Creating Your Organization (${formState.organization_name}...`;
    } else if (configuringUsers) {
        title = `Adding user ${formState.email} to organization ${formState.organization_name}...`;
    } else if (loggingIn) {
        title = `Logging You in as ${formState.email}...`;
    } else if (creatingIntegration) {
        title = `Creating Your ${formState.integration} Integration...`;
    }

    return <Loading fullscreen={true} title={title}/>;
};

export const CreatingAccount = ({
    setActiveStep,
    formState,
    setFormState,
    errors,
    setErrors,
    showPassword,
    setShowPassword,
}) => {
    const dispatch = useDispatch();
    const [creatingUser, setCreatingUser] = useState(false);
    const [creatingOrganization, setCreatingOrganization] = useState(false);
    const [configuringUsers, setConfiguringUsers] = useState(false);
    const [loggingIn, setLoggingIn] = useState(false);
    const [creatingIntegration, setCreatingIntegration] = useState(false);

    useEffect(() => {
        setCreatingUser(true);
        dispatch(createUser(formState)).then((loggedInUser) => {
            setCreatingUser(false);
            setCreatingOrganization(true);
            dispatch(createOrganization(formState.organization_name, loggedInUser)).then(createdOrganization => {
                setCreatingOrganization(false);
                setConfiguringUsers(true);
                dispatch(fetchOrganizationUsers(createdOrganization.id, loggedInUser.id)).then((fetchedOrganizationUsers) => {
                    dispatch(fetchOrganizationUserGroupsForUser(loggedInUser)).then((fetchedOrganizationUserGroups) => {
                        setConfiguringUsers(false);
                        setLoggingIn(true);
                        dispatch(userLoggedIn({
                            user: loggedInUser,
                            organizationUsers: fetchedOrganizationUsers,
                            organizationUserGroups: fetchedOrganizationUserGroups,
                            organizations: [createdOrganization]
                        })).then(() => {
                            setLoggingIn(false);
                            dispatch(selectOrganization(createdOrganization));
                            setCreatingIntegration(true);
                            if (formState.integration === METRC) {
                                dispatch(createMetrcAccount(formState, createdOrganization)).then(() => {
                                    setCreatingIntegration(false);
                                }).catch(err => {
                                    console.error("Error creating Metrc account: ", err);
                                    setCreatingIntegration(false);
                                    setErrors({...errors, integration: "Failed to create Metrc account."});
                                });
                            } else if (formState.integration === DUTCHIE) {
                                dispatch(createLeaflogixAccount(formState, createdOrganization)).then(() => {
                                    setCreatingIntegration(false);
                                }).catch(err => {
                                    console.error("Error creating Dutchie account: ", err);
                                    setCreatingIntegration(false);
                                    setErrors({...errors, integration: "Failed to create Dutchie account."});
                                });
                            }
                        });
                    });
                });
            });
        }).catch(err => {
            console.log("Error creating account: ", err);
            setCreatingUser(false);
            setCreatingOrganization(false);
            setConfiguringUsers(false);
            setLoggingIn(false);
            setCreatingIntegration(false);
            setErrors({...errors, ...err});
        });
    });


    if (creatingUser || creatingOrganization || configuringUsers || loggingIn) {
        return <div className="create-account-creating-account-container">
            <h2>Creating Account</h2>
            <CreatingAccountSpinner
                creatingUser={creatingUser}
                creatingOrganization={creatingOrganization}
                configuringUsers={configuringUsers}
                loggingIn={loggingIn}
                creatingIntegration={creatingIntegration}
            />
        </div>;
    }
    // Check that every key in the errors object is set to "":
    const hasErrors = Object.keys(errors).some((key) => errors[key] !== "");
    if (hasErrors) {
        return <div className="create-account-creating-account-container">
            <h2>Error Creating Account</h2>
            <p>There was an error creating your account. Please check the following:</p>
            <ul>
                {Object.keys(errors).map((errorKey) => (
                    <li key={errorKey}>{errorKey}: {errors[errorKey]}</li>
                ))}
            </ul>
            <p>Please try again or contact support if the issue persists.</p>
        </div>;
    }

    return <div className="create-account-creating-account-container">
        <h2>Account Creation Complete</h2>
        <p>Your account has been created! Please check your email ({formState.email}) for a confirmation link.</p>
        <p>If you do not see the email, please check your spam folder.</p>
    </div>;
};


export default CreatingAccount;